import AgenciaImportPage from "./AgenciaImportPage";

export {AgenciaImportPage}
export default AgenciaImportPage
